import { ErrorMessage, Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import LabelR from '../../../../components/Simple/LabelR';

export const ReferralSignUpInput = ({ name, label, placeholder, helpRender, errors, touched, numeric }) => {
  const formikProps = useFormikContext();

  const isNumber = (value) => !Number.isNaN(Number(value));

  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (numeric && !isNumber(inputValue)) {
      formikProps.setFieldTouched(name, true);
      formikProps.setFieldError(name, 'El valor puede ser solo númerico');
    } else {
      formikProps.setFieldValue(name, inputValue);
      formikProps.validateField(name);
    }
  };

  return (
    <div className="form-group form-item">
      {helpRender}
      <LabelR htmlFor={name}>{label}</LabelR>
      <Field id={name} name={name} className={`form-control ${errors[name] && touched[name] ? 'is-invalid' : ''}`} placeholder={placeholder} onChange={handleChange} />
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </div>
  );
};

ReferralSignUpInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  helpRender: PropTypes.element,
  numeric: PropTypes.bool,
};

export default ReferralSignUpInput;
